import { IMetaTag } from '@/models/metaTags.model';
import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';
import TableActions from '../TableActions/TableActions';
import { formatDate } from '@/utils';

type TGetTableColumns = {
  t: TFunction;
  onDelete: (item: IMetaTag) => void;
  onEdit: (item: IMetaTag) => void;
  canManage: boolean;
};

export const getMetaTagsTableColumns = ({
  t,
  onDelete,
  onEdit,
  canManage,
}: TGetTableColumns): ColumnsType<IMetaTag> => [
  {
    title: t('metatags_slug_label'),
    dataIndex: 'slug',
    key: 'slug',
  },
  {
    title: t('metatags_updated_at'),
    dataIndex: 'updated_at',
    key: 'updated_at',
    render: (updated_at) => formatDate(updated_at),
  },
  ...(canManage
    ? [
        {
          title: t('metatags_actions'),
          key: 'actions',
          render: (_: unknown, record: IMetaTag) => (
            <TableActions record={record} onEdit={onEdit} onDelete={onDelete} />
          ),
        },
      ]
    : []),
];
